import { createTheme } from '@healthinal/ui';

export const theme = createTheme(
  {
    primary: {
      hue: 184,
    },
    neutral: {
      hue: 184,
    },
  },
  {
    components: {
      JoyTooltip: {
        styleOverrides: {
          root: {
            maxWidth: 440,
          },
        },
        defaultProps: {
          arrow: true,
          variant: 'outlined',
        },
      },
      JoyFormControl: {
        styleOverrides: {
          root: {
            '&.MuiFormControl-horizontal': {
              width: '100%',
              '> *': {
                flex: 1,
              },
            },
          },
        },
      },
    },
  },
);
